import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

export const PARTNER_BEACON_RESOURCES_PAGE_VIDEOS = [
  {
    cover: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        src="../assets/images/partner_beacon-overview-1.jpg"
        alt=""
      />
    ),
    heading: 'How to capture a property?',
    body: 'Beacon 3D+ transforms smartphone photos into a fully measured, customizable 3D model. In this video, we explain how you can successfully capture images using the Beacon 3D+ app so you can receive your interactive 3D model and all accurate measurements faster.',
    href: 'https://fast.wistia.net/embed/iframe/bdnxsfc4vz?autoPlay=true',
  },
  {
    cover: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        src="../assets/images/partner_beacon-overview-2.jpg"
        alt=""
      />
    ),
    heading: 'Interactive Measurements',
    body: 'Beacon 3D+ delivers accurate exterior measurements on an interactive 3D model. In this video, we show you how you can access all exterior measurements for every facet of a property, so you can eliminate extra trips to the job site.',
    href: 'https://fast.wistia.net/embed/iframe/9d5ctjwrdt?autoPlay=true',
  },
  {
    cover: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        src="../assets/images/partner_beacon-overview-3.jpg"
        alt=""
      />
    ),
    heading: 'Interactive 3D Model & Design Features',
    body: "Beacon 3D+'s design features take out the guesswork by showing you exactly what your next project will look like. In this video, we show you how you can design the perfect home, and show homeowners what different products and colors will look like on an interactive 3D model.",
    href: 'https://fast.wistia.net/embed/iframe/vm9wongy9e?autoPlay=true',
  },
  {
    cover: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        src="../assets/images/partner_beacon-overview-4.jpg"
        alt=""
      />
    ),
    heading: 'Online Platform',
    body: "With Beacon 3D+'s online platform you can oversee all your properties’ photos, 3D model, and measurements in one place. In this video, we provide a few tips on how you can adjust your settings and user specific permissions to get the most out of Beacon 3D+.",
    href: 'https://fast.wistia.net/embed/iframe/u4u4u38c5g?autoPlay=true',
  },
  {
    cover: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        src="../assets/images/partner_beacon-overview-5.jpg"
        alt=""
      />
    ),
    heading: 'Now - Roof squares in minutes.',
    body: 'The Now feature provides a roof square estimate within 30 minutes of submitting photos, so you can pull together a quote while still onsite.',
    href: 'https://fast.wistia.net/embed/iframe/2iq9x8l9xb?autoPlay=true',
  },
  {
    cover: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        src="../assets/images/partner_beacon-overview-6.jpg"
        alt=""
      />
    ),
    heading:
      'Connect Feature - Engage the homeowner early on in the sales process.',
    body: 'With Connect, you can capture a property remotely by allowing homeowners to take photos of their house. That way, you can provide an estimate remotely or be fully prepared with the customizable 3D model and measurements prior to a meeting.',
    href: 'https://fast.wistia.net/embed/iframe/qwy0ywbeo6?autoPlay=true',
  },
  {
    cover: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        src="../assets/images/partner_beacon-overview-7.jpg"
        alt=""
      />
    ),
    heading: 'Prospect Feature - Get the most out of your field team.',
    body: 'Prospect allows organizations to review and approve the photos coming in from the field before submitting them. That way, admins can order the 3D model and measurements for the leads that actually sit for an appointment.',
    href: 'https://fast.wistia.net/embed/iframe/hloc2znjs5?autoPlay=true',
  },
];
